import Http from "./http";

export const getAllMaterialAPI = (payload) => {
  return Http.post("admin/material/list", payload);
};
